import script from "./SignUpComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SignUpComponent.vue?vue&type=script&setup=true&lang=js"

import "./SignUpComponent.vue?vue&type=style&index=0&id=4a09db3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a09db3e"]])

export default __exports__